import React from 'react';
import { Card } from '@mui/material';
import { RelPoint, RelSide } from 'src/config';
import RelCard from './RelCard';
import * as types from '../../../types';
import _ from 'lodash';

const RelContainer: React.FC<{
    vector: RelPoint,
    entities: types.Entity[] | undefined,
    parentLocator: types.Locator;
    stack: types.StackItem[],
    renderItemActions: (entity: types.Entity) => React.ReactElement,
    renderEmptyActions?: () => React.ReactElement,
}> = ({
    vector,
    entities,
    parentLocator,
    stack,
    renderItemActions,
    renderEmptyActions,
}) => {
        const { rel, side } = vector;
        const items: boolean = entities != null && entities.length > 0;
        const inverse = side === RelSide.TARGET;

        const getLoopIndex: (enitity: types.Entity) => number = (entity) => {
            if (entity != null) {
                const name: string = rel[inverse ? 'resource' : 'related'];
                const id = entity.values['_id']|| entity.attrs['_id'];
                return _.findIndex(stack, si => si.locator.name === name && si.locator.id === id.toString());
            }
            return -1;
        }

        return (
            <Card
                variant={items ? "elevation" : "outlined"}
                sx={{
                    p: items || renderEmptyActions ? 0.2 : 2.3,
                    borderColor: theme => theme.palette.grey[300],
                }}
            >
                {
                    entities?.map((entity, index) => (

                        <RelCard
                            key={index}
                            rel={rel}
                            inverse={inverse}
                            entity={entity}
                            parentLocator={parentLocator}
                            renderActions={renderItemActions}
                            index={index}
                            loopIndex={getLoopIndex(entity)}
                        />
                    ))
                }
                {
                    !items && renderEmptyActions && renderEmptyActions()
                }
            </Card>
        )
    }

export default RelContainer;



